<template>
    <Line id="chart-wrapper" :data="chartData" :options="options" />
</template>

<script>
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement } from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement)

export default {
    name: 'BarChart',
    components: { Line },
    props: ['data'],
    data() {
        return {
            chartData: {
                labels: this.data.labels,
                datasets: [
                    {
                        label: 'Daily Stats',
                        backgroundColor: '#00DD00',
                        borderColor: '#00EE00',
                        fill: false,
                        data: this.data.values,
                        tension: 0.1
                    }
                ]
            },
            options: {
                showScale: true,
                scales: {
                    x: {
                        display: true,
                        ticks: {
                            display: false
                        },
                        border: {
                            display: true,
                            color: '#555555'
                        }
                    },
                    y: {
                        display: true,
                        ticks: { color: '#00CC00', beginAtZero: true }
                    }
                },
                elements: {
                    point: {
                        radius: 2
                    }
                },
                responsive: true,
            }
        }
    }
}
</script>

<style>
#chart-wrapper {
    display: inline-block;
    position: relative;
    width: 100%;
}
</style>
